import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { GAnalyticsService } from 'src/app/services/g-analytics.service';
import { MenuCotacaoItem } from './menu-nova-cotacao';
import { TourStepsService } from 'src/app/services/tour-steps.service';
import { TrialService } from 'src/app/services/trial.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';

//temporário
const SAUDE_PRODUTO_ID = 11;

@Component({
  selector: 'app-menu-nova-cotacao',
  templateUrl: './menu-nova-cotacao.component.html',
  styleUrls: ['./menu-nova-cotacao.component.scss'],
  standalone: false,
})
export class MenuNovaCotacaoComponent {
  private readonly trialService = inject(TrialService);
  private readonly apiUsuario = inject(ApiUsuarioService);

  public menusCotacao = input<MenuCotacaoItem[]>([]);
  public isMenuOpen: boolean = false;
  public isSaudeCTAVisible = this.trialService.showCTA(SAUDE_PRODUTO_ID);

  public readonly queryParams = computed(() => {
    const corretoraIdView = this.apiUsuario.corretoraIdView();
    return corretoraIdView ? { corretoraId: corretoraIdView } : null;
  });

  public readonly menuCotacaoComputed = computed(() => {
    return this.menusCotacao().map((p) => {
      //atualmente só estará checando trial para o modulo saúde
      if (!p.produtoId) return p;

      const status = this.trialService.getStatus(p.produtoId);

      return {
        ...p,
        trial: status === 'TRIALLING',
      };
    });
  });

  constructor(
    private router: Router,
    private gAnalytics: GAnalyticsService,
    public tourStepsService: TourStepsService,
  ) {}

  openPage() {
    this.isMenuOpen = false;
  }
}
